import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import UpdateMailSetting            from "../../../../../application/usecase/mail/setting/UpdateMailSetting";
import MailSetting                  from "../../../../../domain/mail/setting/MailSetting";
import { ResKaState }               from "../../../../../index";

const MailSettingUpdateButton: FC = () => {
  const mailSetting: MailSetting = useSelector((state: ResKaState) => state.mailSetting);
  const updateMailSetting: UpdateMailSetting = new UpdateMailSetting(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateMailSetting.execute(mailSetting) }
      >
        <Icon name="save"/>
        保存する
      </Button>
    </>
  );
};

export default MailSettingUpdateButton;
